module.exports = __webpack_public_path__ + "static/media/delete-24px.2fc9a828.svg";